import React, { Component } from 'react';

class Demo extends Component {
  handleEmailClick = () => {
    // Construct the mailto link with recipient, subject, and body (optional)
    const recipient = 'example@email.com';
    const subject = 'Regarding your inquiry';
    const body = 'Hello,\n\nI am writing to you about...';

    const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Open the default email client
    window.location.href = mailtoLink;
  };

  render() {
    return (
      <button onClick={this.handleEmailClick}>
        Send Email
      </button>
    );
  }
}

export default Demo;